// detect touch devices (global variable)
var isTouchDevice = 'ontouchstart' in document.documentElement || 'ontouchstart' in window || navigator.msMaxTouchPoints;

var isCSSTransitionSupported = function() {
	var b = document.body || document.documentElement,
		s = b.style,
		p = 'transition';

	if (typeof s[p] == 'string') { return true; }

	// Tests for vendor specific prop
	var v = ['Moz', 'webkit', 'Webkit', 'Khtml', 'O', 'ms'];
	p = p.charAt(0).toUpperCase() + p.substr(1);

	for (var i=0; i<v.length; i++) {
		if (typeof s[v[i] + p] == 'string') { return true; }
	}

	return false;
};

var matches = function(ele, selector) {
	return (
		ele.matches ||
		ele.matchesSelector ||
		ele.msMatchesSelector ||
		ele.mozMatchesSelector ||
		ele.webkitMatchesSelector ||
		ele.oMatchesSelector
	).call(ele, selector);
};

// Find the closest element to `ele` and matches the `selector`
var closest = function(ele, selector) {
	var e = ele;
	while (e) {
		if (matches(e, selector)) {
			break;
		}
		e = e.parentNode;
	}
	return e;
};



/**
 * Fade-in background on hover
 */

var hoverableItems = document.querySelectorAll('.js-fadein-background');

for (var i = 0 ; i < hoverableItems.length; i++) {
	hoverableItems[i].addEventListener('mouseenter', function() {
		const allBanners = document.querySelectorAll('.js-banner');
		for (var j = 0; j < allBanners.length; j++){
			allBanners[j].classList.remove('homepage-banner__fadein-layer--animation');
		}

		const targetId = this.getAttribute('data-id');
		const banner = document.querySelector('.js-banner-' + targetId);
		banner.classList.add('homepage-banner__fadein-layer--before-animation');

		setTimeout(function() {
			banner.classList.add('homepage-banner__fadein-layer--animation');
		}, 50);
	});

	hoverableItems[i].addEventListener('mouseleave', function() {
		const targetId = this.getAttribute('data-id');
		const banner = document.querySelector('.js-banner-' + targetId);
		banner.classList.remove('homepage-banner__fadein-layer--animation');
	});
}
